import validator from 'validator'

export const validateDomain = (domain: string) => {
  const isValidURL = validator.isURL(domain.trim(), {
    protocols: ['http', 'https'],
    allow_fragments: false,
    allow_query_components: false,
    require_valid_protocol: true,
    disallow_auth: true,
  })

  const hasNoPath = /^((https?:\/\/)?[^/?#]+)$/i.test(domain.trim())

  return isValidURL && hasNoPath
}

export const validateEmail = (email: string) => validator.isEmail(email)

export const validateSpecialCharacters = (str: string) => {
  return /[!"#$%&'()*+./:;<=>?@[\\\]^_`{|}~-]/.test(str)
}

export const validatePhoneNumber = (phone: string) => {
  return /^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/.test(phone)
}

export const validateInputOnlyNumbers = (e: React.ChangeEvent<HTMLInputElement>) => {
  const re = /^[0-9]+$/
  if (e.target.value === '' || re.test(e.target.value)) {
    return true
  }
  return false
}
